var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetaGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14258 0C1.93344 0 0.142578 1.79086 0.142578 4V12C0.142578 14.2091 1.93344 16 4.14258 16H12.1426C14.3517 16 16.1426 14.2091 16.1426 12V4C16.1426 1.79086 14.3517 0 12.1426 0H4.14258Z",
    fill: "#5F6877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92963 2.32601C8.49495 1.89133 7.7902 1.89133 7.35552 2.32601L5.17723 4.5043L8.14258 7.46965L11.1079 4.5043L8.92963 2.32601Z",
    fill: "#9E9DAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6383 5.03463L8.67291 7.99998L11.6383 10.9653L13.8166 8.78705C14.2512 8.35238 14.2512 7.64762 13.8166 7.21294L11.6383 5.03463Z",
    fill: "#9E9DAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1079 11.4957L8.14258 8.53031L5.17721 11.4957L7.35552 13.674C7.7902 14.1087 8.49495 14.1087 8.92963 13.674L11.1079 11.4957Z",
    fill: "#9E9DAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64688 10.9653L7.61225 7.99998L4.6469 5.03463L2.46859 7.21294C2.03391 7.64762 2.03391 8.35238 2.46859 8.78705L4.64688 10.9653Z",
    fill: "#9E9DAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaGray);
export default __webpack_public_path__ + "static/media/metaGray.4619320878c24c098c791d1219dfe3f3.svg";
export { ForwardRef as ReactComponent };